export default "__VITE_ASSET__VsZJ08oF__"